import DigiobcanApi from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';
import type { QueryFunctionContext } from '@tanstack/react-query';

type Params = Parameters<typeof DigiobcanApi.adminGetReports>[0];

export const adminGetReports = createQueryFn(
  QueryNameSpace.adminGetReports,
  async ({
    queryKey,
    pageParam,
  }: QueryFunctionContext<[string] | [string, Params], number>) => {
    const [, params] = queryKey;

    const data = await DigiobcanApi.adminGetReports({
      ...params,
      offset: pageParam,
    });

    return data;
  },
);
